import React, {useEffect} from 'react';
import {Container, Header, IconButton, Title, ButtonsContainer} from './styles';
import Button from '../../components/atoms/Buttons/CommonBtn';
import {theme} from '../../styles/darkTheme';
import BackArrow from '../../assets/icons/BackArrow.svg';
import {useTranslation} from '../../context/language';
import Accordion from '../../components/atoms/Accordion';
import Footer from '../../components/molecules/Footer';

const Info = () => {
  const {text} = useTranslation();
  const handleClickBack = () => {
    window.history.back();
  };

  const handleClick = () => {
    //@ts-ignore
    FreshworksWidget('open');
  };

  return (
    <Container theme={theme}>
      <Header theme={theme}>
        <ButtonsContainer>
          <div onClick={handleClickBack}>
            <IconButton src={BackArrow} size={24} />
          </div>
          <Button onClick={handleClick}>{text.support}</Button>
        </ButtonsContainer>
        <Title theme={theme}>{text.faq}</Title>
      </Header>
      <Title style={{margin: 20}} theme={theme}>{text.resetUsers}</Title>
      <Accordion data={text.questions} />
      <Title style={{margin: 20}} theme={theme}>{text.topiiUsers}</Title>
      <Accordion data={text.questionsTopii} />
      <Footer />
    </Container>
  );
};

export default Info;
